import { compact } from 'lodash/fp';
import { ComponentProps } from 'react';

import { EditorCombinedStepSchema } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/types';
import TranslationEditSection from 'dashboard/apps/InquiryTemplateEditor/TranslationEditSection';
import {
  CombinedStepConfig,
  InquiryTemplateVersionCombinedStep,
} from 'dashboard/models/inquiry-template-version';
import { CombinedStepClientData } from 'lib/interfaces/StepsConfig';

export const getCombinedEditCardConfigs = ({
  stepPreview,
  pageKeys,
  basePath,
  combinedStepSchema,
}: {
  step: InquiryTemplateVersionCombinedStep;
  stepPreview: CombinedStepClientData;
  // TODO: CombinedStepConfig['localizations'] is not right - it just gets the common localization keys between
  //        the 3 combined steps instead of the union of all the localization keys
  pageKeys: Array<keyof CombinedStepConfig['localizations']>;
  basePath: string;
  combinedStepSchema: EditorCombinedStepSchema;
}): {
  name: string;
  section: Pick<ComponentProps<typeof TranslationEditSection>, 'config' | 'label'>;
}[] => {
  const placeholders: Record<string, string> = pageKeys.reduce(
    (map, key) => ({
      ...map,
      ...stepPreview.config.localizations[key],
    }),
    {},
  );

  return pageKeys.flatMap((pageKey) =>
    compact(
      combinedStepSchema.translations[pageKey]?.map((translationSchema) => {
        const {
          label,
          'client-key': clientKey,
          'custom-translations-key': translationsKey,
        } = translationSchema;
        return {
          name: clientKey,
          section: {
            label: label,
            config: {
              path: `${basePath}.config.localizations.${pageKey}.${translationsKey}`,
              stepName: stepPreview.name,
              name: pageKey,
              translationsKey: `localizations.${pageKey}.${translationsKey}`,
              clientKey,
              defaultValue: placeholders[clientKey],
            },
          },
        };
      }),
    ),
  );
};
